var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit2 = function SvgEdit2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.744 1.91a.833.833 0 0 1 1.179 0l4.166 4.167a.833.833 0 0 1 0 1.179L7.256 18.089a.83.83 0 0 1-.59.244H2.5a.833.833 0 0 1-.833-.833v-4.167a.83.83 0 0 1 .244-.589zm-9.41 11.768v2.989H6.32l10-10-2.988-2.988-10 10Z"
  })));
};
export default SvgEdit2;